export default function initTeamModals() {
    const teamMembers = document.querySelectorAll('.team-member');
    const body = document.querySelector('body');

    teamMembers.forEach((teamModal) => {
        const modalOpen = teamModal.querySelector('.team-member-button');
        const modalClose = teamModal.querySelector('.team-member-modal-close-button');
        const modal = teamModal.querySelector('.team-member-modal');

        if (!modalOpen || !modalClose || !modal) {
            return;
        }

        modalOpen.addEventListener('click', () => {
            modal.classList.add('active');
        });

        modalClose.addEventListener('click', () => {
            modal.classList.remove('active');
        });

        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.classList.remove('active');
            }
        });
    });
}